import { cn, formatMessage } from '@util/index';

interface MessageContentProps {
  content: string;
  isOutbound?: boolean;
  isSupport?: boolean;
  className?: string;
  onRightClick?: (ev: React.MouseEvent) => void;
  isSidebar?: boolean;
}

export default function MessageContent({
  content,
  isOutbound,
  isSupport,
  className,
  onRightClick,
  isSidebar,
}: MessageContentProps) {
  const baseStyles = isOutbound
    ? 'rounded-bl-[1.5rem] rounded-tl-[1.5rem] rounded-tr-[1.5rem] bg-brand-secondary text-white'
    : `rounded-br-[1.5rem] rounded-tl-[1.5rem] rounded-tr-[1.5rem] ${
        isSupport
          ? 'bg-[#444] text-zinc-100'
          : 'bg-brand-lightest-gray text-brand-black'
      }`;

  const padding = isOutbound ? 'p-[1.6rem]' : 'p-[1.2rem]';

  return (
    <div
      className={cn('flex flex-col text-left', padding, baseStyles, className)}
      onContextMenu={onRightClick}
    >
      <p
        className={cn(
          'message-content whitespace-pre-line break-words text-[1.5rem]',
          isSidebar ? 'max-w-[40rem]' : 'max-w-[30rem] sm:max-w-[50rem]'
        )}
        dangerouslySetInnerHTML={{
          __html: formatMessage(content).html,
        }}
      />
    </div>
  );
}
